import { render, staticRenderFns } from "./CoachingSection.vue?vue&type=template&id=325c04e8&scoped=true&"
import script from "./CoachingSection.vue?vue&type=script&lang=js&"
export * from "./CoachingSection.vue?vue&type=script&lang=js&"
import style0 from "./CoachingSection.vue?vue&type=style&index=0&id=325c04e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325c04e8",
  null
  
)

export default component.exports